module.exports = __webpack_public_path__ + "img/1.38744764.png";